<template lang="pug">
  v-row
    v-col(cols="12")
      h1.mb-6 Виджеты пользователя

    permissions-wrapper.fill-width(
      :roles="[$conf.ROLES.organization]"
      v-slot:default
    )
      .d-flex.align-center
        h3.ma-3 Виджеты
        v-divider
      create-widget

      v-btn.mt-3(
        color="secondary"
        depressed
        rounded
        :to="{ name: 'WidgetList' }"
      )
        span Открыть созданные виджеты
        v-icon.ml-2 mdi-folder
</template>

<script>

import CreateWidget from '@/modules/Widgets/components/CreateWidget.vue';

export default {
  name: 'UserSettings',
  components: {
    CreateWidget,
  },
};
</script>
